import template from './tableGridDropdownCell.html';
import controller from './tableGridDropdownCell.controller';

let tableGridDropdownCellComponent = () => {
  return {
    restrict: 'E',
    scope: {
      row: '=',
      columnName: '@',
      columns: '=',
      metaData: '='
    },
    template,
    controller,
    controllerAs: 'vm'
  };
};

export
default tableGridDropdownCellComponent;


// WEBPACK FOOTER //
// ./app/components/tableGridDropdownCell/tableGridDropdownCell.component.js